import type { LessonCreateStore } from './interfaces'

export const getters = {
  isLoading: (state: LessonCreateStore): boolean => state.loading,
  getSlots: (state: LessonCreateStore): LessonCreateStore['slots'] => state.slots,
  getType: (state: LessonCreateStore): LessonCreateStore['type'] => state.type,
  getToday: (state: LessonCreateStore): LessonCreateStore['today'] => state.today,
  getDate: (state: LessonCreateStore): LessonCreateStore['date'] => state.date,
  getStartTime: (state: LessonCreateStore): LessonCreateStore['startTime'] => state.startTime,
  getDuration: (state: LessonCreateStore): LessonCreateStore['duration'] => state.duration,
  /** The lesson start as the API takes it: 'Y-m-d H:i:s', or '' while the date or time is not chosen. */
  getStart: (state: LessonCreateStore): string => (state.date && state.startTime ? `${state.date} ${state.startTime}:00` : ''),
  getTutorId: (state: LessonCreateStore): LessonCreateStore['tutorId'] => state.tutorId,
  getAppliedFilters: (state: LessonCreateStore): LessonCreateStore['appliedFilters'] => state.appliedFilters,
  isTutorModalOpen: (state: LessonCreateStore): boolean => state.tutorModalOpen,
  isSaving: (state: LessonCreateStore): boolean => state.saving,
}
